import HelpPage from './helpPage';

export default HelpPage;